import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environment';
import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { PlaceNamePipe } from '@app/pipes/place-name.pipe';
import { RecentSearchPackages } from '@recent-searches/entities/recent-search';
import { RecentSearchBaseComponent } from '@recent-searches/components/recent-search-base.component';
import { packagesResultRootRoute } from '@packages/packages-result/constants/packages-result.routes';
import { SearchParamFromType } from '@search-bar/entities/search-type';
import { mapRecentAirPackageSearchData } from '@search-bar/mappers/url-search.mapper';
import { HotelDestinationInputType } from '@shared/base-search-bar/entities/autocomplete-destionation';

@Component({
  selector: 'app-air-package-recent-search',
  templateUrl: './air-package-recent-search.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AirPackageRecentSearchComponent extends RecentSearchBaseComponent {

  constructor(
    protected router: Router,
    protected datePipe: DatePipe,
    protected dateTransformPipe: DateTransformPipe,
    protected placeNamePipe: PlaceNamePipe,
    protected changeDetector: ChangeDetectorRef
  ) {
    super(router, datePipe, dateTransformPipe, placeNamePipe, changeDetector);
  }

  get airPackageSearch(): RecentSearchPackages {
    return this.search as RecentSearchPackages;
  }

  get getNamePlaces$(): Observable<string> {
    return combineLatest([
      this.placeNamePipe.transform(this.airPackageSearch.from),
      this.placeNamePipe.transform(this.airPackageSearch.to)
    ]).pipe(map(([fromName, toName]) => `${fromName.split(',')[0]} a ${toName.split(',')[0]}`));
  }

  get getPackageRooms(): number {
    return this.airPackageSearch?.rooms?.length ?? 0;
  }

  get getPackageTravelers(): number {
    return this.getPackageRooms === 0 ? 0 :
      this.airPackageSearch.rooms.reduce<number>(
        (prev, room) => prev + room.guests.reduce<number>(
          (sum, guest) => sum + guest.quantity, 0)
        , 0);
  }

  get showHotelName(): boolean {
    return this.airPackageSearch?.destination_location_type === HotelDestinationInputType.hotel
      && !!this.airPackageSearch.destination_hotel_name;
  }

  public searchAirPackage(): void {
    const _search = {
      ...this.airPackageSearch,
      departuredate: this.formatDateBySearch(this.airPackageSearch?.departuredate),
      arrivaldate: this.formatDateBySearch(this.airPackageSearch?.arrivaldate)
    };
    const urlParams = mapRecentAirPackageSearchData(_search);
    this.router.navigate(
      [`${packagesResultRootRoute}/${urlParams}`],
      {
        queryParams: {
          source: SearchParamFromType.RECENT,
          branch_code: _search?.branch_code ? _search.branch_code : environment.branchcode,
          from: SearchParamFromType.RECENT
        }
      });
  }

}
